import { Users, BadgeEuro, Zap, Layers } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import ServiceArea from "@/components/ServiceArea";
import CTASection from "@/components/CTASection";
import ZWImage from "@/components/ZWImage";

const WERTE = [
  {
    icon: Users,
    title: "Persönlich vor Ort",
    text: "Zwei Brüder, feste Ansprechpartner – keine Subunternehmer, keine wechselnden Gesichter. Sie sprechen direkt mit demjenigen, der die Arbeit macht.",
  },
  {
    icon: Zap,
    title: "Schnell & zuverlässig",
    text: "Auch kurzfristige Einsätze sind für uns selbstverständlich – bei Sturmschäden, Mieterwechseln oder plötzlichem Wintereinbruch.",
  },
  {
    icon: Layers,
    title: "Alles aus einer Hand",
    text: "Garten, Hausmeister, Reinigung, Winterdienst: Ein Anruf deckt die gesamte Immobilie ab – ohne Schnittstellen und ohne Mehrfachanfahrt.",
  },
  {
    icon: BadgeEuro,
    title: "Feste Preise ohne Überraschungen",
    text: "Bei uns wissen Sie vorher, was es kostet. Alle Preise stehen offen auf der Website – netto und brutto.",
  },
];

export default function UeberUns() {
  return (
    <>
      <SEO
        title="Über uns – Zwei Brüder aus Herten | ZWILLINGSWERK"
        description="ZWILLINGSWERK ist der Garten- & Hausmeisterservice zweier Brüder aus Herten. Persönlich vor Ort, feste Preise, alles aus einer Hand – im Umkreis von 20 km."
      />
      <PageHero
        eyebrow="Über uns · Das Brüder-Team"
        title="Zwei Brüder. Ein Ziel. Saubere Arbeit. Starke Ergebnisse."
        description="ZWILLINGSWERK ist unser gemeinsamer Betrieb in Herten. Wir sind zwei Brüder, die ihren Namen unter jede Arbeit setzen – vom Rasenschnitt bis zur Objektbetreuung."
        testid="ueber-hero"
      />

      {/* Brüder-Story */}
      <section className="py-16 bg-white border-b border-[#D7E5D9]" data-testid="story-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-5">
              <ZWImage
                src="/images/brueder-echt.webp"
                fallback="/images/brueder.png"
                alt="Die beiden Brüder und Inhaber von ZWILLINGSWERK aus Herten – echtes Foto"
                className="w-full aspect-[4/3] rounded-2xl shadow-lg"
                subcaption="Das Team"
                caption="Persönlich vor Ort – bei jedem Auftrag"
                testid="brueder-image"
              />
            </div>
            <div className="lg:col-span-7 space-y-5">
              <span className="text-xs font-bold text-[#1E5631] uppercase tracking-wider">Unsere Geschichte</span>
              <h2 className="text-3xl sm:text-4xl font-black text-[#122B18] font-display">
                Aus Herten, für Herten – und das ganze Vest
              </h2>
              <p className="text-[#4A634E] text-base leading-relaxed">
                Wir sind in Herten zuhause und kennen die Gärten, Wohnanlagen und Gewerbeobjekte im Revier. Als
                Brüder-Team arbeiten wir ausschließlich selbst: Wer bei uns anruft, bekommt keine wechselnden
                Aushilfen, sondern die beiden Inhaber persönlich aufs Grundstück.
              </p>
              <p className="text-[#4A634E] text-base leading-relaxed">
                Unser Anspruch ist einfach: saubere Arbeit zu festen Preisen. Deshalb stehen alle unsere Preise offen
                auf dieser Website – netto für Gewerbe und Verwaltungen, brutto für Privatkunden. Und weil wir wissen,
                dass im Alltag oft alles schnell gehen muss, sind auch kurzfristige Einsätze für uns selbstverständlich.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Werte */}
      <section className="py-16 bg-[#F2F7F2] border-b border-[#D7E5D9]" data-testid="werte-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center space-y-3 mb-12">
            <span className="text-xs font-bold text-[#1E5631] uppercase tracking-wider">Unsere Werte</span>
            <h2 className="text-3xl sm:text-4xl font-black text-[#122B18] font-display">
              Darauf können Sie sich verlassen
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {WERTE.map((w) => (
              <div
                key={w.title}
                className="bg-white border border-[#D7E5D9] rounded-xl p-6 space-y-3 shadow-sm"
                data-testid={`wert-${w.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                <div className="w-10 h-10 rounded-lg bg-[#E6F3E6] text-[#1E5631] flex items-center justify-center">
                  <w.icon className="w-5 h-5" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-bold text-[#122B18]">{w.title}</h3>
                <p className="text-sm text-[#4A634E] leading-relaxed">{w.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ServiceArea />
      <CTASection />
    </>
  );
}
